module.exports = __webpack_public_path__ + "static/media/icn_kebab.873f8267.svg";